import { useMemoizedFn } from 'ahooks';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { toUpperCase } from 'utils/toLowerCase';
import { useTranslate } from '@tolgee/react';
import { lazy } from 'react';

const WhatsAppTemplatePreview = lazy(() => import('components/WhatsAppTemplatePreview'));

export const TemplateMsg = (props: BaseMsgProps) => {
  const { msg } = props;
  const {
    raw: { templateContent },
  } = msg;

  const { t } = useTranslate();
  const { parameters, header, text = '', footer, buttons } = templateContent || {};

  const getHeader = useMemoizedFn(() => {
    if (!header) {
      return header;
    }

    if (header.type === 'text') {
      return {
        ...header,
        type: 'TEXT',
      } as const;
    }

    const fileUrl = parameters?.find(({ label }) => label === 'File')?.content;

    return {
      ...header,
      type: toUpperCase(header.type),
      previewUrl: fileUrl || header.previewUrl,
    };
  });

  return (
    <MessageExtendComplex
      {...props}
      content={
        <WhatsAppTemplatePreview
          style={{
            width: '242px',
          }}
          template={{
            header: getHeader(),
            contents: [{ text }],
            footer,
            buttons,
          }}
          assets={{
            pdfTitleText: t('ViewsChat.pdf第一页缩略图'),
            pdfNameText: t('ViewsChat.文件名'),
            contentPlaceholder: t('ViewsChat.输入后话术预览展示在这里'),
          }}
        />
      }
    />
  );
};
